module.exports = __webpack_public_path__ + "static/img/rtf.22546818.png";